import Nav from '../components/nav';
import SideNav from '../components/sidenav';

export default function Layout({ children }) {
  return (
    <>
      <Nav />
      <SideNav />
      <div className='p-4 sm:ms-64 flex-1'>
        <div className='p-4  mt-14 flex-1'>
          <div className='flex justify-center mb-4 rounded flex-1 content'>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
